import React from 'react';
import { DEFAULT_AVATAR } from '../../../../../shared/utils/matrix/matrixRoomUtils';
import ChatMessageStatus from './ChatMessageStatus';

/**
 * Ended voice/video call notice — compact pill card with call icon + duration (matches call-state bubble style).
 * @param {Object} props
 * @param {{ media: 'audio' | 'video', text: string, title?: string, duration?: string }} props.endedCallInfo - From parseEndedCallNotice
 * @param {boolean} [props.pending]
 * @param {boolean} [props.failed]
 * @param {string} props.timeLabel
 * @param {boolean} props.isMine
 * @param {string} props.otherAvatar
 */
const ChatEndedCall = ({
  endedCallInfo,
  pending = false,
  failed = false,
  timeLabel,
  isMine = false,
  otherAvatar,
}) => {
  const mainIconClass =
    endedCallInfo.media === 'video'
      ? 'fa-solid fa-video'
      : 'fa-solid fa-phone with_top_right_icon';
  const title =
    endedCallInfo.title ||
    (endedCallInfo.media === 'video' ? 'Video Call Ended' : 'Voice Call Ended');
  const duration = endedCallInfo.duration || null;
  const fallbackBody = endedCallInfo.text;

  return (
    <div
      className={`cm_chat cm_chat_ended_call ${isMine ? 'your_msg' : 'incomming_msg'}`}
    >
      {!isMine && (
        <img
          className="sender_img"
          src={otherAvatar || DEFAULT_AVATAR}
          alt=""
          aria-hidden
        />
      )}
      <div className="cm_chat_content">
        <div
          className="cm_ended_call_card"
          role="status"
          aria-label={endedCallInfo.text}
        >
          <div className="cm_ended_call_row">
            <div
              className={`cm_ended_call_icon_stack ${endedCallInfo.media === 'video' ? 'cm_ended_call_icon_stack_circle cm_ended_call_icon_video' : 'cm_ended_call_icon_voice'}`}
              aria-hidden
            >
              <i className={mainIconClass} />
            </div>
            <div className="cm_ended_call_copy">
              <span className="cm_ended_call_title">{title}</span>
              {duration ? (
                <span className="cm_ended_call_duration">Duration: {duration}</span>
              ) : (
                <span className="cm_ended_call_duration">{fallbackBody}</span>
              )}
            </div>
          </div>
        </div>
        <div className="cm_chat_meta cm_chat_meta_missed">
          <ChatMessageStatus pending={pending} failed={failed} />
          {timeLabel ? <time>{timeLabel}</time> : null}
        </div>
      </div>
    </div>
  );
};

export default React.memo(ChatEndedCall);
